import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableRow
} from "@mui/material";

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    packagesFeaturesSearchRoleModulesRequest,
    packagesFeaturesSearchRoleModulesByIdRequest,
    packagesFeaturesUpdateRoleModulesRequest,
    packagesFeaturesSetRoleModules,
    clearRedux,
} from 'Redux/actions';

//Tables
import TablePM from 'Modules/packages/.components/featureTab/.components/pmTable';
import TablePX from 'Modules/packages/.components/featureTab/.components/pxTable';

//Styles
import './index.scss'

const FeatureTab = (props) => {
    const { currentPackage, height } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [allRead, setAllRead] = useState(false);
    const [allCreate, setAllCreate] = useState(false);
    const [allUpdate, setAllUpdate] = useState(false);
    const [allDelete, setAllDelete] = useState(false);
    const [changes, setChanges] = useState(false);

    const { loading, roleModules, template, update, updateLoading } = useSelector(state => state.packagesFeatureTabRedux);


    const applyChanges = () => {
        let currenModules = null
        if (currentPackage?.projectId === "PM") {
            let currentRoleModules = template.filter((item) => (item?.r))
            currenModules = currentRoleModules.map((item) => ({ moduleId: item?.id, c: item?.c, u: item?.u, d: item?.d }))
        } else {
            let currentRoleModules = template.filter((item) => item.r || item.code === "realtimemaps");
            currenModules = currentRoleModules.map((item) => ({ moduleId: item?.id, isDefault: item.code === "realtimemaps" ? true : item?.isDefault || false }))
        }

        let payload = {
            id: currentPackage?.id,
            name: currentPackage?.name,
            permissions: currenModules
        }
        
        dispatch(packagesFeaturesUpdateRoleModulesRequest(payload))
    }

    useEffect(() => {
        dispatch(packagesFeaturesSearchRoleModulesRequest(currentPackage?.projectId));
    }, [])

    useEffect(() => {
        if (template && template.length > 0 && !roleModules) {
            dispatch(packagesFeaturesSearchRoleModulesByIdRequest(currentPackage?.id));
        }
    }, [template]);

    useEffect(() => {
        if (roleModules) {
            let currentRoleModules = JSON.parse(JSON.stringify(template));
            currentRoleModules?.length && currentRoleModules.map((rolemodule, index) => {
                let indexRole = roleModules.find((item) => rolemodule?.id === item?.moduleId)
                if (indexRole) {
                    currentRoleModules[index].r = true
                    if (currentPackage?.projectId === "PM") {
                        currentRoleModules[index].c = indexRole.c
                        currentRoleModules[index].u = indexRole.u
                        currentRoleModules[index].d = indexRole.d
                    } else {
                        currentRoleModules[index].isDefault = indexRole.isDefault
                    }
                }
            })
            dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
        }
    }, [roleModules]);

    //Clear
    useEffect(() => {
        return () => {
            dispatch(clearRedux("PACKAGES_FEATURES_TAB"));
            setAllRead(false);
            setAllCreate(false);
            setAllUpdate(false);
            setAllDelete(false);
            setChanges(false);
        }
    }, [])

    //Update
    useEffect(() => {
        if (update) {
            if (update?.id) {
                NotificationManager.success(
                    messages['packages_features_success_message'],
                    messages['packages_features_title'],
                    3000
                );
                setChanges(false);
            } else {
                NotificationManager.error(
                    messages['packages_features_error_message'],
                    messages['packages_features_title'],
                    3000
                );
            }
            dispatch(clearRedux("PACKAGES_FEATURES_TAB", { update: null }))
        }
    }, [update])

    return (
        <Container className="features-tab-container" maxWidth={false}>
            <Table
                stickyHeader={false}
                aria-label="Data View"
                size={'medium'}
                style={{ display: "table" }}
            >
                <TableBody>
                    <TableRow>
                        <TableCell style={{ minWidth: 1000, padding: 0, borderBottom: 'none' }}>
                            {
                                currentPackage?.projectId === "PM" ? (
                                    <TablePM
                                        id={0}
                                        template={template}
                                        loading={loading || updateLoading}
                                        setChanges={setChanges}
                                        applyChanges={applyChanges}
                                        changes={changes}
                                        allRead={allRead}
                                        setAllCreate={setAllCreate}
                                        setAllDelete={setAllDelete}
                                        setAllUpdate={setAllUpdate}
                                        setAllRead={setAllRead}
                                        allCreate={allCreate}
                                        allUpdate={allUpdate}
                                        allDelete={allDelete}
                                        height={height}
                                    />
                                ) : (
                                    <TablePX
                                        id={0}
                                        template={template}
                                        loading={loading || updateLoading}
                                        setChanges={setChanges}
                                        changes={changes}
                                        applyChanges={applyChanges}
                                        height={height}
                                    />
                                )
                            }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    )
}
export default FeatureTab